<template>
<v-container
      v-if="getSelectedResource !== null"
      class="organizations--overview--context__container pa-0"
    >
      <v-row class="pa-0 organizations--overview--context__layout" no-gutters>
        <v-col class="pl-1" cols="12">
          <ContextTitle
          :title__20="true"
          :title="organization.name"
          :enableInfoIcon="false"
          >
            <template #custom--icon>
            <!-- TODO BE logo is missing if name contains climax then mocked logo, else placeholder -->
            <img v-if="organization.logo !== null" :src="organization.logo">
            <v-btn
            style="width: 26px;height:26px;margin-top:1px;"
            class="mb-0 ml-0 mr-1"
            v-else
            fab
            small
            disabled
            depressed
            >
              <v-icon size="14" >far fa-building</v-icon>
            </v-btn>
          </template>
          </ContextTitle>
        </v-col>
        <v-col cols="12">
           <ContextItemNoEditable
            :icon="'fas fa-link'"
            :iconTooltip="$t('organizations.ref')"
            :attribute="organization.ref"
            :isCopyable="true"
          />
          <ContextItemLabels
            :isEditable="false"
            :iconTooltip="$t('shipments.labels')"
            :labels="computeOrganizationLabels"
            :algoliaSearchLabels="null"
            :emptyLabel="''"
          />
          <!-- TODO: add to i18n -->
          <ContextItem
            :icon="'fas fa-building'"
            :iconTooltip="$t('companies.dic')"
            :actionIcons="{copy: organization.vatNo}"
            :attribute="organization.vatNo"
          />
          <!-- TODO: add to i18n -->
          <ContextItemNoEditable
            :iconTooltip="$t('locations.address')"
            :icon="'fas fa-map-marker-alt'"
            :attribute="organization.address | AddressObjectToString([['street', 'streetNo'], 'postalCode', ['city', 'countryCode']])"
            :isCopyable="true"
          />
          <!-- TODO: add to i18n -->
          <ContextItem
            v-if="false"
            :icon="'fas fa-globe-europe'"
            :iconTooltip="'Website'"
            :actionIcons="{copy: organization.contacts.web.name}"
            :attribute="organization.contacts.web.name"
            :hrefLink="organization.contacts.web.url"
          />
          <!-- TODO: add to i18n -->
          <ContextItem
            v-if="false"
            :icon="'fas fa-phone'"
            :iconTooltip="'Company Phone Number'"
            :actionIcons="{copy: organization.contacts.phone}"
            :attribute="organization.contacts.phone"
          />
          <!-- TODO: add to i18n -->
          <ContextItem
            v-if="false"
            :icon="'fas fa-at'"
            :iconTooltip="'Company Email'"
            :actionIcons="{copy: organization.contacts.email.url}"
            :hrefLink="organization.contacts.email.url"
            :attribute="organization.contacts.email.name"
          />
          <ContextLabel v-if="false" :labels="organization.groups" />
        </v-col>
        <v-col class="pt-1" cols="12">
          <ContextTitle
            :title="$t('organizations.description')"
            class="mb-1"
            :enableInfoIcon="false"
          />
          <p class="about">{{organization.about}}</p>
        </v-col>
      </v-row>
    </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { organizationService } from '@/_services'
import ContextTitle from '@/components/drops/detail/ContextTitle'
import ContextItem from '@/components/wrld/generic/ContextItem'
import ContextItemLabels from '@/components/wrld/generic/ContextItemLabels'
import ContextItemNoEditable from '@/components/wrld/generic/ContextItemNoEditable'
import ContextLabel from '@/components/drops/detail/ContextLabel'

export default {
  name: 'OrganizationsContextCard',
  components: {
    ContextTitle,
    ContextLabel,
    ContextItem,
    ContextItemLabels,
    ContextItemNoEditable
  },
  mounted () {
    if (this.getOrganizationResourceDetails === null) {
      organizationService.getOrganization({ organizationID: this.$route.params.organizationID }).then((organization) => {
        this.setOrganizationDetails({ organizationDetails: organization })
      })
    }
  },
  methods: {
    ...mapActions({
      setOrganizationDetails: 'setOrganizationDetails'
    })
  },
  computed: {
    ...mapGetters(['getSelectedResource', 'getOrganizationResourceDetails']),
    organization () {
      return {
        ...this.getOrganizationResourceDetails,
        openHours: {
          from: '8:00',
          to: '17:00'
        }
      }
    },
    computeOrganizationLabels () {
      let organizationLabels = []
      if (this.organization.labels !== null) {
        this.organization.labels.forEach((label) => {
          organizationLabels.push({ name: label, color: '#ef476f', noTranslate: true })
        })
      }
      return organizationLabels
    }
  }
}
</script>

<style lang="scss" scoped>
  .organizations--overview--context__container {
    border-bottom: 2px solid #f2f2f2;
    .about {
      color: #767676;
      font-size: 13px;
      font-weight: bold;
      flex: 1 1 max-content;
      margin-right: 5px;
    }
  }
</style>
